import { COMPUTER_DEFAULT_SORT } from "~/constants/computer";

export default () => ({
  agency: null,
  computers: null,
  vaccineDeployments: {},
  currentComputer: null,
  lastVersion: "",
  loading: false,
  tags: [],
  page: 0,
  sortBy: COMPUTER_DEFAULT_SORT.sortBy,
  orderBy: COMPUTER_DEFAULT_SORT.orderBy,
  search: "",
});
